import React from 'react'
import queryString from 'query-string'
import { RouteComponentProps } from '@reach/router'
import EmployeeDetailsDialog from 'components/EmployeeManagement/EmployeeDetailsDialog'
import EmployeeImportDialog from 'components/EmployeeManagement/EmployeeImportFlow'
import TicketDetailsDialog from 'components/TicketManagement/Show'
import LeaseDetailsDialog from 'components/LeaseManagement/Details'
import NeighborhoodDetailsDialog from 'components/NeighborhoodManagement/NeighborhoodDetailsDialog'
import NewNeighborhoodDialog from 'components/NeighborhoodManagement/NewNeighborhoodDialog'
import NeighborhoodImportDialog from 'components/NeighborhoodManagement/NeighborhoodImport/NeighborhoodImportDialog'
import BuildingDialog from 'components/BuildingManagement/BuildingDetailsDialog'
import FloorDialog from 'components/BuildingManagement/FloorDetailsDialog'
import NewWorkplaceDialog from 'components/WorkplaceGroupManagement/NewWorkplaceGroupDialog'
import WorkplaceGroupDetailsDialog from 'components/WorkplaceGroupManagement/WorkplaceGroupDetailsDialog'
import PortfolioDialog from 'components/Portfolio/Details'
import NewAssetDialog from 'components/AssetManagement/NewAssetDialog'
import AssetDetailsDialog from 'components/AssetManagement/AssetDetails'
import DepartmentDetailsDialog from 'components/DepartmentManagement/DepartmentDetailsDialog'
import BookingImportDialog from 'components/BookingsManagement/BookingImportFlow'
import BuildingTypeDialog from 'components/BuildingTypeManagement/BuildingTypeDetails'
import SpaceTypeDialog from 'components/SpaceTypeManagement/SpaceTypeDetails'
import isString from '@utils/isString'

export interface ReloadFunc {
  (): void
}

interface ModalLayerProps extends RouteComponentProps {
  reload?: ReloadFunc
}

export default function ModalLayer(props: ModalLayerProps) {
  if (!props.navigate || !props.location) return null

  const search = queryString.parse(props.location.search) as {
    [k: string]: string
  }

  if (isString(search.newItem)) {
    switch (search.newItem) {
      case 'neighborhood':
        return <NewNeighborhoodDialog floorId={search.floorId} navigate={props.navigate} />
      case 'workplaceGroup':
        return <NewWorkplaceDialog navigate={props.navigate} />
      case 'employeeImport':
        return <EmployeeImportDialog navigate={props.navigate} reload={props.reload} />
      case 'bookingsImport':
        return <BookingImportDialog navigate={props.navigate} reload={props.reload} />
      case 'neighborhoodsImport':
        return <NeighborhoodImportDialog navigate={props.navigate} reload={props.reload} />
      case 'assetTag':
        return <NewAssetDialog navigate={props.navigate} reload={props.reload} />
    }
  }

  let C
  if (search.employeeId) C = EmployeeDetailsDialog
  if (search.leaseId) C = LeaseDetailsDialog
  if (search.ticketId) C = TicketDetailsDialog
  if (search.neighborhoodId) C = NeighborhoodDetailsDialog
  if (search.workplaceGroupId) C = WorkplaceGroupDetailsDialog
  if (search.buildingId) C = BuildingDialog
  if (search.floorId) C = FloorDialog
  if (search.portfolioBuildingId) C = PortfolioDialog
  if (search.assetId) C = AssetDetailsDialog
  if (search.departmentId) C = DepartmentDetailsDialog
  if (search.buildingTypeId) C = BuildingTypeDialog
  if (search.spaceTypeId) C = SpaceTypeDialog
  if (C) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <C {...props} {...search} openInEdit={search.edit === 'true'} />
  }
  return null
}
